import * as React from "react";
import { forwardRef } from "react";
const SvgBigArrowBottom = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 10, height: 13, viewBox: "0 0 10 13", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9.00635 7.01172L5.00835 11.0117L1.00635 7.01172", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }), /* @__PURE__ */ React.createElement("path", { d: "M5.00635 11.0117L5.00635 1.01172", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgBigArrowBottom);
export default ForwardRef;
